import React from 'react';
import _ from "lodash";

const DefaultOfflinePaymentResult = ({ offlinePmtMsg }) => {

  if (!_.isEmpty(offlinePmtMsg)) {
    return (
      <div> <pre style={{fontSize: "14px",
        fontFamily: 'Roboto, Helvetica Neue, Arial, sans-serif'}}>
        {offlinePmtMsg}
      </pre>
      </div>
    )
  } else {
    return (
      <div>
        <b>To make an offline donation follow the below instructions:</b>
        <ol>
          <li>Write a check payable to charitable orgnaization you are donating to</li>
          <li>On the memo line of the check, indicate the donation cause.</li>
          <li>Mail your check to the charitable organization</li>
        </ol>
        Your tax-deductible donation receipt will be issued once we confirm that the amount is received.</div>
    )
  }
}

export default DefaultOfflinePaymentResult



